export const isGlobalArticleDetail = (detail) =>
  detail?.companyUnitId == null || detail.companyUnitId === "" || Number(detail.companyUnitId) === 0;

export function getBaseRowIndex(form) {
  const details = form.articleotherDetails || [];
  const marked = details.findIndex(detail => detail.isBaseRow);
  if (marked >= 0) return marked;
  if (!form.barcode || !form.unitId) return -1;
  return details.findIndex(detail =>
    isGlobalArticleDetail(detail) &&
    detail.newBarcode === form.barcode &&
    Number(detail.articleUnitID) === Number(form.unitId) &&
    Number(detail.typeOfSales || 1) === 1
  );
}
